
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bZDTF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4d3547983ad81d8e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $4d3547983ad81d8e$export$2e2bcd8739ae039 = {
    'confluence-analytics-byline.abbreviated-user-views.message': '{count, plural, =0 {Visninger} one {1} other {{count}}}',
    'confluence-analytics-byline.page-viewers.message': "L\xe6sere",
    'confluence-analytics-byline.user-views.message': '{count, plural, =0 {Analyser} one {Set af 1 person} other {Set af {count} personer}}'
};

});


//# sourceMappingURL=da.ce8c5ecd.js.map
